export default __webpack_public_path__ + "static/compareItemImg3-de98e80330713d56cbcbd26e2c96770a.png";